import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat-error" }
const _hoisted_2 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_tooltip = _resolveComponent("el-tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([$props.mode])
    }, [
      _createVNode(_component_Icon, {
        class: "icon",
        height: "2rem",
        width: "2rem",
        icon: "alert-circle",
        stroke: $options.c_icon
      }, null, 8 /* PROPS */, ["stroke"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString($options.text), 1 /* TEXT */),
      _createVNode(_component_el_tooltip, {
        disabled: $props.disabled,
        content: "Error copied to clipboard",
        placement: "top",
        effect: "light",
        visible: $data.tooltip_visible
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            style: {"outline":"none"},
            class: "icon copy pointer",
            stroke: $options.c_icon,
            "stroke-width": "2",
            icon: "clipboard",
            width: "2rem",
            height: "2rem",
            onClick: $options.onCopy
          }, null, 8 /* PROPS */, ["stroke", "onClick"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "visible"])
    ], 2 /* CLASS */)
  ]))
}